import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Events } from 'ionic-angular';

/*
  Generated class for the ProductsProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class ProductsProvider {

  productlist: any = [];

  constructor(
    public gateway: GatewayClientProvider,
    public http: Http, public events: Events) {
  }

  getProducts() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getaccounttypesandproducts()
        .then((data) => {
          self.productlist = data;
          resolve(self.productlist)
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getExistingCustomerDetails(customerId) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getExistingCustomerDetails(customerId)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getProductExistingCustomerDetails(customerId, account_types_id, products_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getProductExistingCustomerDetails(customerId, account_types_id, products_id)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  registerProductAction(product, url) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.registerProductAction(product, url)
        .then(() => {
          resolve(true);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getSubProducts(productId) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getSubProducts(productId)
        .then((data: any) => {
          if (data.status) {
            if (data.data.length > 0) {
              self.productlist = self.sortSubProducts(data);
              resolve(self.productlist)
            }
            else {
              self.productlist = data;
              resolve(self.productlist)
            }
          }
          else {
            self.productlist = data;
            resolve(self.productlist)

          }
        }).catch((err) => {
          reject(err);
        })
    })
  }

  sortSubProducts(result) {
    let data: any = null;
    data = JSON.parse(JSON.stringify(result.data));
    for (let i = 0; i < data.length; i++) {
      if (data[i].title.split(".").length > 2) {
        let split_arr1 = data[i].title.split(".")
        data[i].year = split_arr1[split_arr1.length - 1].split(" ")[0];
      }
      else {
        data[i].year = 1;
      }
    }

    data.sort(function (a, b) {
      var keyA = parseInt(a.year),
        keyB = parseInt(b.year);
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });
    result.data = JSON.parse(JSON.stringify(data));
    return result;
  }

  isProductRead(productid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.isProductRead(productid)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  isProductInterested(productid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.isProductInterested(productid)
        .then(() => {
          resolve(true);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  productViewed(product) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.productViewed(product)
        .then(() => {
          resolve(true);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  get_CustomerBadgeCount(customers_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getCustomerBadgeCount(customers_id)
        .then((count) => {
          resolve(count);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getAllActiveProducts() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getProducts()
        .then((count) => {
          resolve(count);
        }).catch((err) => {
          reject(err);
        })
    });
  }

  getMaturityProducts(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getMaturityProducts(data)
        .then((count) => {
          resolve(count);
        }).catch((err) => {
          reject(err);
        })
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/products/products.ts